var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusRejectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    fillRule: "evenodd",
    d: "M11.50029406 11.48146638V4.50009802c0-.2760541-.22404391-.50009802-.50009802-.50009802-.2760541 0-.50009802.22304372-.50009802.50009802v6.98136836c0 .27605411.22404391.50009802.50009802.50009802.2760541 0 .50009802-.22404391.50009802-.50009802z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-3",
    cx: 11,
    cy: 14.982,
    rx: 1,
    ry: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10.5,
    fill: "rgb(255,108,13)",
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "rgb(255,255,255)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "rgb(255,255,255)",
    xlinkHref: "#ellipse-3"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    xlinkHref: "#ellipse-3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRejectedIcon);
export default __webpack_public_path__ + "static/media/status-rejected-icon.67f719e3.svg";
export { ForwardRef as ReactComponent };